export default "__VITE_ASSET__AKQePI5T__"